import React, { useState, useEffect } from "react";
import "./BlogFrontend.css";
import blogdummyImg from './BlogPic/blog1.jpg'

const BlogFrontend = () => {
  const [blog, setBlog] = useState([]);

  useEffect(() => {
    getBlog();
  }, []);

  const getBlog = async () => {
    let result = await fetch("http://localhost:5000/blogs");
    result = await result.json();
    setBlog(result);
  };
  return (
    <div className="blogs-page-conainer-avcom">
      <h2 className="blog-heading-blog-frontend">Blogs</h2>
      <div className="each-blog-conainer-frontend">
      <ul className="each-blog-container-of-frontend-box">
            {/* <li>{index+1}</li> */}
            <li className="heading-of-blog-page-box">Heading</li>
            <li className="blog-image-frontend-image-container"><img src={blogdummyImg} alt="blog" /></li>
            <li className="blog-details-text-blog-page">Lorem ipsum dolor sit amet consectetur adipisicing elit. Velit magni natus, aliquam incidunt ipsa, sint dicta vero esse similique nobis quios?</li>
            <li className="author-of-particualr-blog">Author:- thakur</li>
            <button className="read-more-button-of-blog-page">
              Read more..
            </button>
          </ul>

        {blog.map((item, index) => (
          <ul className="each-blog-container-of-frontend-box">
            {/* <li>{index+1}</li> */}
            <li className="heading-of-blog-page-box">{item.title}</li>
            <li className="blog-image-frontend-image-container">{item.image}</li>
            <li className="blog-details-text-blog-page">{item.detailText}</li>
            <li className="author-of-particualr-blog">Author:- {item.author}</li>
            <button className="read-more-button-of-blog-page">
              Read more..
            </button>
          </ul>
        ))}
      </div>
    </div>
  );
};

export default BlogFrontend;
